import React, { useMemo, useState } from 'react';
import ProductCard from '../components/ProductCard';
import './Products.css';

//Apparel products
import pdtGraphicTees from "../assets/pdt-graphic-tee1.png";
import pdtJogger from "../assets/pdt-joggers1.png";
import pdtKidsSet1 from "../assets/pdt-kids-set1.png";
import pdtKidsSet2 from "../assets/pdt-kids-set2.png";
import pdtRomper from "../assets/pdt-romper.png";
import pdtRomper2 from "../assets/pdt-romper2.png";
import pdtRomper3 from "../assets/pdt-romper3.png";
import pdtRomper4 from "../assets/pdt-romper4.png";
import pdtSweatshirt from "../assets/pdt-sweatshirts1.png";
import pdtWomens1 from "../assets/pdt-womens1.png";
import pdtWomens2 from "../assets/pdt-womens2.png";
import pdtBodySuit from "../assets/pdt-bodysuit1.png";
import pdtBodySuit2 from "../assets/pdt-bodysuit2.png";
import pdtBodySuit3 from "../assets/pdt-bodysuit3.png";
import pdtTshirt1 from "../assets/pdt-tshirt1.png";
import pdtTshirt2 from "../assets/pdt-tshirt2.png";
import pdtTshirt3 from "../assets/pdt-tshirt3.png";
import pdtHoodie1 from "../assets/pdt-hoodie1.png";
import pdtHoodie2 from "../assets/pdt-hoodie2.png";
import pdtsl1 from "../assets/pdt-sl1.png";
import pdtHoodie3 from "../assets/pdt-hoodie3.png";
import pdtHoodie4 from "../assets/pdt-hoodie4.png";
import pdtSweatshirt2 from "../assets/pdt-sweatshirt2.png";
import pdtSweatshirt3 from "../assets/pdt-sweatshirt3.png";
import pdtSweatshirt4 from "../assets/pdtsweatshirt4.png";
import pdtSweatpant1 from "../assets/pdt-sweatpant.png";
import pdtSweatpant2 from "../assets/pdt-sweatpant2.png";
import pdtSweatpant3 from "../assets/pdt-sweatpant3.png";
import pdtJogger2 from "../assets/pdt-jogger2.png";
import pdtJogger3 from "../assets/pdt-joggers3.png";
import pdtPyjamaKids from "../assets/pdt-pyjama-kids.png";
import pdtRomper5 from "../assets/pdt-romper5.png";
import pdtTshirt4 from "../assets/pdt-tshirt4.png";
import sl2 from "../assets/pdt-sl2.png";
import shorts1 from "../assets/pdt-shorts1.png";
import shorts2 from "../assets/pdt-shorts2.png";
import shorts3 from "../assets/pdt-shorts3.png";
import shorts4 from "../assets/pdt-shorts4.png";
import pdtTshirt5 from "../assets/pdt-tshirt5.png";
import pdtRomper8 from "../assets/pdt-romper8.png";
import pdtRomper9 from "../assets/pdt-romper9.png";
import pdtFrc from "../assets/pdt-frc.png";
import pdtGDress1 from "../assets/pdt-gdress1.png";
import pdtGDress2 from "../assets/pdt-gdress2.png";
import pdtGDress3 from "../assets/pdt-gdress3.png";
import pdtGDress4 from "../assets/pdt-gdress4.png";
import pdtGDress5 from "../assets/pdt-gdress5.png";
import pdtGDress6 from "../assets/pdt-gdress6.png";
import pdtGDress7 from "../assets/pdt-gdress7.png";
import pdtGDress8 from "../assets/pdt-gdress8.png";
import pdtJumpsuit1 from "../assets/pdt-jumpsuit1.png";
import pdtKidsPack from "../assets/pdt-kids-pack.png";
import pdtKidsSet1Copy from "../assets/pdt-kids-set1 copy.png";
import pdtKidsSet2Copy from "../assets/pdt-kids-set2 copy.png";
import pdtKidsSet3 from "../assets/pdt-kids-set3.png";
import pdtKidsSet4 from "../assets/pdt-kids-set4.png";
import pdtMedicalScrubsAlt from "../assets/pdt-medicalscrubs.png";
import pdtShortsCombo from "../assets/pdt-shorts-combo.png";
import pdtShorts5 from "../assets/pdt-shorts5.png";
import pdtShorts6 from "../assets/pdt-shorts6.png";
import pdtShorts7 from "../assets/pdt-shorts7.png";
import pdtSl3 from "../assets/pdt-sl3.png";
import pdtTshirtKids1 from "../assets/pdt-tshirt-kids1.png";


//Woven garment products
import pdtArcSuit from "../assets/pdt-arcsuit.png";
import pdtFrcSuit from "../assets/pdt-frc-suit.png";
import pdtFrcCoverall from "../assets/pdt-frc-coverall.png";
import pdtMedicalScrubs from "../assets/pdt-medical-scrubs2.png";
import pdtUnifromPolos from "../assets/pdt-uniform-polos.png";
import shirtImg from "../assets/pdt-shirt.png";
import boxerImg from "../assets/pdt-boxer-shorts.jpg";
import pyjamaImg from "../assets/pdt-pyjama1.png";
import pyjamaImg2 from "../assets/pdt-pyjama2.png";
import printedShirt1 from "../assets/pdt-printed-shirt1.png";



//Home textile products
import apronImg from "../assets/pdt-apron.jpg";
import tableCothImg from "../assets/pdt-table-cloth.png";
import laundryBagImg from "../assets/pdt-laundry-bag.jpg";
import totebagImg from "../assets/pdt-totebag.jpg";
import fcushionImg from "../assets/pdt-floor-cushion.jpg";
import bathTowelsImg from "../assets/pdt-bath-towels.png";

import bathRobesImg from "../assets/home-textile/bath-robes.png";
import beachtowelsImg from "../assets/home-textile/beach-towels.jpg";
import benchcoverImg from "../assets/home-textile/bench-covers.jpg";
import chairCoverImg from "../assets/home-textile/chair-covers.png";
import chairPadsImg from "../assets/home-textile/chair-pad-cushions.jpg";
import curtainsImg from "../assets/home-textile/curtains.jpg";
import fruitBagsImg from "../assets/home-textile/fruit-bags.jpg";
import handTowelsImg from "../assets/home-textile/hand-towels.png";
import napkinImg from "../assets/home-textile/napkins.jpg";
import oventMitsPotsImg from "../assets/home-textile/oven_mits-pots.jpg";
import placematImg from "../assets/home-textile/placemat.png";
import runnersImg from "../assets/home-textile/runners.jpg";
import showerCurtainsImg from "../assets/home-textile/shower-curtains.jpg";
import sofaThrowImg from "../assets/home-textile/sofa_throws.png";



//import TCyarnImg from "../assets/home-textile/pdt-table-cloth-yarndyed.png";
//import TCyarnImg2 from "../assets/home-textile/pdt-table-cloth-yarndyed2.png";
//import TCprintedImg from "../assets/home-textile/pdt-table-cloth-printed.png";
//import TCprintedImg2 from "../assets/home-textile/pdt-table-cloth-printed2.png";
//import TCprintedImg3 from "../assets/home-textile/pdt-table-cloth-printed3.png";
//import TCjuteImg from "../assets/home-textile/pdt-table-cloth-jute.png";




const PRODUCTS = [
	{
		id: 'P-3001',
		sku: 'SK-GT-3001',
		name: 'Graphic Tee',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGraphicTees,
		tags: ['tee', 'graphic', 'casual'],
		description: 'Trendy graphic tee for everyday style.',
	},
	{
		id: 'P-3002',
		sku: 'SK-JG-3002',
		name: 'Joggers',
		factory: 'Apparels',
		price: 9.99,
		image: pdtJogger,
		tags: ['joggers', 'pants', 'casual'],
		description: 'Comfortable joggers for active wear.',
	},
	{
		id: 'P-4001',
		sku: 'SK-KS-4001',
		name: 'Kids Set 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsSet1,
		tags: ['kids', 'set', 'outfit'],
		description: 'Fun and colorful kids clothing set.',
	},
	{
		id: 'P-4002',
		sku: 'SK-KS-4002',
		name: 'Kids Set 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsSet2,
		tags: ['kids', 'set', 'outfit'],
		description: 'Stylish kids set for all occasions.',
	},
	{
		id: 'P-4003',
		sku: 'SK-KS-4003',
		name: 'Kids Set 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsSet3,
		tags: ['kids', 'set', 'outfit'],
		description: 'Comfortable kids set made for everyday wear.',
	},
	{
		id: 'P-4004',
		sku: 'SK-KS-4004',
		name: 'Kids Set 4',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsSet4,
		tags: ['kids', 'set', 'outfit'],
		description: 'Playful kids set with a relaxed fit.',
	},
	{
		id: 'P-4011',
		sku: 'SK-KS-4011',
		name: 'Kids Set 1 Copy',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsSet1Copy,
		tags: ['kids', 'set', 'outfit'],
		description: 'Alternate kids set design for casual use.',
	},
	{
		id: 'P-4012',
		sku: 'SK-KS-4012',
		name: 'Kids Set 2 Copy',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsSet2Copy,
		tags: ['kids', 'set', 'outfit'],
		description: 'Additional kids set style for daily comfort.',
	},
	{
		id: 'P-4013',
		sku: 'SK-KP-4013',
		name: 'Kids Pack',
		factory: 'Apparels',
		price: 9.99,
		image: pdtKidsPack,
		tags: ['kids', 'pack', 'outfit'],
		description: 'Kids combo pack suitable for regular wear.',
	},
	{
		id: 'P-5001',
		sku: 'SK-RP-5001',
		name: 'Romper',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Soft and comfy romper for babies.',
	},
	{
		id: 'P-5002',
		sku: 'SK-RP-5002',
		name: 'Romper 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper2,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Adorable romper with playful design.',
	},
	{
		id: 'P-5003',
		sku: 'SK-RP-5003',
		name: 'Romper 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper3,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Classic romper for everyday comfort.',
	},
	{
		id: 'P-5004',
		sku: 'SK-RP-5004',
		name: 'Romper 4',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper4,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Romper with unique patterns.',
	},
	{
		id: 'P-5005',
		sku: 'SK-RP-5005',
		name: 'Romper 5',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper5,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Soft romper designed for everyday comfort.',
	},
	{
		id: 'P-5008',
		sku: 'SK-RP-5008',
		name: 'Romper 8',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper8,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Lightweight romper with a clean everyday style.',
	},
	{
		id: 'P-5009',
		sku: 'SK-RP-5009',
		name: 'Romper 9',
		factory: 'Apparels',
		price: 9.99,
		image: pdtRomper9,
		tags: ['romper', 'baby', 'one-piece'],
		description: 'Comfort-first romper made for daily wear.',
	},
	{
		id: 'P-5101',
		sku: 'SK-JS-5101',
		name: 'Jumpsuit 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtJumpsuit1,
		tags: ['jumpsuit', 'one-piece', 'casual'],
		description: 'Stylish jumpsuit offering all-day comfort.',
	},
	{
		id: 'P-6001',
		sku: 'SK-SW-6001',
		name: 'Sweatshirt',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatshirt,
		tags: ['sweatshirt', 'warm', 'casual'],
		description: 'Cozy sweatshirt for chilly days.',
	},
	{
		id: 'P-7001',
		sku: 'SK-WM-7001',
		name: 'Women\'s Top 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtWomens1,
		tags: ['women', 'top', 'fashion'],
		description: 'Elegant women\'s top for any occasion.',
	},
	{
		id: 'P-7002',
		sku: 'SK-WM-7002',
		name: 'Women\'s Top 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtWomens2,
		tags: ['women', 'top', 'fashion'],
		description: 'Stylish women\'s top with modern look.',
	},
	{
		id: 'P-7101',
		sku: 'SK-GD-7101',
		name: 'Girls Dress 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress1,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Elegant girls dress for festive and casual use.',
	},
	{
		id: 'P-7102',
		sku: 'SK-GD-7102',
		name: 'Girls Dress 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress2,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Comfortable girls dress with a modern cut.',
	},
	{
		id: 'P-7103',
		sku: 'SK-GD-7103',
		name: 'Girls Dress 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress3,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Breathable girls dress made for daily wear.',
	},
	{
		id: 'P-7104',
		sku: 'SK-GD-7104',
		name: 'Girls Dress 4',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress4,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Relaxed-fit girls dress with soft fabric.',
	},
	{
		id: 'P-7105',
		sku: 'SK-GD-7105',
		name: 'Girls Dress 5',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress5,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Classic girls dress suitable for all occasions.',
	},
	{
		id: 'P-7106',
		sku: 'SK-GD-7106',
		name: 'Girls Dress 6',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress6,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Stylish girls dress with lightweight comfort.',
	},
	{
		id: 'P-7107',
		sku: 'SK-GD-7107',
		name: 'Girls Dress 7',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress7,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Everyday girls dress designed for movement.',
	},
	{
		id: 'P-7108',
		sku: 'SK-GD-7108',
		name: 'Girls Dress 8',
		factory: 'Apparels',
		price: 9.99,
		image: pdtGDress8,
		tags: ['girls', 'dress', 'fashion'],
		description: 'Premium girls dress with a soft touch feel.',
	},
	{
		id: 'P-8001',
		sku: 'SK-BS-8001',
		name: 'Bodysuit 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtBodySuit,
		tags: ['bodysuit', 'baby', 'one-piece'],
		description: 'Comfortable bodysuit for babies.',
	},
	{
		id: 'P-8002',
		sku: 'SK-BS-8002',
		name: 'Bodysuit 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtBodySuit2,
		tags: ['bodysuit', 'baby', 'one-piece'],
		description: 'Soft bodysuit with cute prints.',
	},
	{
		id: 'P-8003',
		sku: 'SK-BS-8003',
		name: 'Bodysuit 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtBodySuit3,
		tags: ['bodysuit', 'baby', 'one-piece'],
		description: 'Essential bodysuit for daily wear.',
	},
	{
		id: 'P-8101',
		sku: 'SK-TS-8101',
		name: 'T-Shirt 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtTshirt1,
		tags: ['tshirt', 'casual', 'top'],
		description: 'Classic t-shirt for everyday comfort.',
	},
	{
		id: 'P-8102',
		sku: 'SK-TS-8102',
		name: 'T-Shirt 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtTshirt2,
		tags: ['tshirt', 'casual', 'top'],
		description: 'Soft t-shirt with a modern fit.',
	},
	{
		id: 'P-8103',
		sku: 'SK-TS-8103',
		name: 'T-Shirt 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtTshirt3,
		tags: ['tshirt', 'casual', 'top'],
		description: 'Versatile t-shirt suitable for daily wear.',
	},
	{
		id: 'P-8104',
		sku: 'SK-TS-8104',
		name: 'T-Shirt 4',
		factory: 'Apparels',
		price: 9.99,
		image: pdtTshirt4,
		tags: ['tshirt', 'casual', 'top'],
		description: 'Everyday t-shirt with a comfortable fit.',
	},
	{
		id: 'P-8106',
		sku: 'SK-TS-8106',
		name: 'T-Shirt 5',
		factory: 'Apparels',
		price: 9.99,
		image: pdtTshirt5,
		tags: ['tshirt', 'casual', 'top'],
		description: 'Breathable t-shirt designed for regular wear.',
	},
	{
		id: 'P-8107',
		sku: 'SK-TS-8107',
		name: 'Kids T-Shirt 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtTshirtKids1,
		tags: ['kids', 'tshirt', 'casual'],
		description: 'Kids t-shirt with breathable everyday comfort.',
	},
	{
		id: 'P-8201',
		sku: 'SK-HD-8201',
		name: 'Hoodie 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtHoodie1,
		tags: ['hoodie', 'warm', 'casual'],
		description: 'Comfortable hoodie for cool-weather layering.',
	},
	{
		id: 'P-8202',
		sku: 'SK-HD-8202',
		name: 'Hoodie 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtHoodie2,
		tags: ['hoodie', 'warm', 'casual'],
		description: 'Stylish hoodie built for comfort and movement.',
	},
	{
		id: 'P-8203',
		sku: 'SK-SL-8203',
		name: 'Sleeveless Top',
		factory: 'Apparels',
		price: 9.99,
		image: pdtsl1,
		tags: ['sleeveless', 'top', 'casual'],
		description: 'Lightweight sleeveless top for warm days.',
	},
	{
		id: 'P-8206',
		sku: 'SK-SL-8206',
		name: 'Sleeveless Top 2',
		factory: 'Apparels',
		price: 9.99,
		image: sl2,
		tags: ['sleeveless', 'top', 'casual'],
		description: 'Relaxed sleeveless style for everyday comfort.',
	},
	{
		id: 'P-8207',
		sku: 'SK-SL-8207',
		name: 'Sleeveless Top 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSl3,
		tags: ['sleeveless', 'top', 'casual'],
		description: 'Breathable sleeveless top for warm-weather wear.',
	},
	{
		id: 'P-8204',
		sku: 'SK-HD-8204',
		name: 'Hoodie 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtHoodie3,
		tags: ['hoodie', 'warm', 'casual'],
		description: 'Relaxed-fit hoodie for all-day comfort.',
	},
	{
		id: 'P-8205',
		sku: 'SK-HD-8205',
		name: 'Hoodie 4',
		factory: 'Apparels',
		price: 9.99,
		image: pdtHoodie4,
		tags: ['hoodie', 'warm', 'casual'],
		description: 'Premium hoodie with a soft finish.',
	},
	{
		id: 'P-8301',
		sku: 'SK-SW-8301',
		name: 'Sweatshirt 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatshirt2,
		tags: ['sweatshirt', 'warm', 'casual'],
		description: 'Cozy sweatshirt with a clean look.',
	},
	{
		id: 'P-8302',
		sku: 'SK-SW-8302',
		name: 'Sweatshirt 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatshirt3,
		tags: ['sweatshirt', 'warm', 'casual'],
		description: 'Comfort-first sweatshirt for regular wear.',
	},
	{
		id: 'P-8303',
		sku: 'SK-SW-8303',
		name: 'Sweatshirt 4',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatshirt4,
		tags: ['sweatshirt', 'warm', 'casual'],
		description: 'Everyday sweatshirt with durable stitching.',
	},
	{
		id: 'P-8401',
		sku: 'SK-SP-8401',
		name: 'Sweatpants 1',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatpant1,
		tags: ['sweatpants', 'bottoms', 'casual'],
		description: 'Comfortable sweatpants for lounging and travel.',
	},
	{
		id: 'P-8402',
		sku: 'SK-SP-8402',
		name: 'Sweatpants 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatpant2,
		tags: ['sweatpants', 'bottoms', 'casual'],
		description: 'Tapered sweatpants built for all-day comfort.',
	},
	{
		id: 'P-8403',
		sku: 'SK-SP-8403',
		name: 'Sweatpants 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtSweatpant3,
		tags: ['sweatpants', 'bottoms', 'casual'],
		description: 'Soft sweatpants with a relaxed fit.',
	},
	{
		id: 'P-8501',
		sku: 'SK-SH-8501',
		name: 'Shorts 1',
		factory: 'Apparels',
		price: 9.99,
		image: shorts1,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Comfortable shorts for casual everyday wear.',
	},
	{
		id: 'P-8502',
		sku: 'SK-SH-8502',
		name: 'Shorts 2',
		factory: 'Apparels',
		price: 9.99,
		image: shorts2,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Lightweight shorts made for warm-weather comfort.',
	},
	{
		id: 'P-8503',
		sku: 'SK-SH-8503',
		name: 'Shorts 3',
		factory: 'Apparels',
		price: 9.99,
		image: shorts3,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Everyday shorts with a flexible fit.',
	},
	{
		id: 'P-8504',
		sku: 'SK-SH-8504',
		name: 'Shorts 4',
		factory: 'Apparels',
		price: 9.99,
		image: shorts4,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Durable shorts for active daily use.',
	},
	{
		id: 'P-8505',
		sku: 'SK-SH-8505',
		name: 'Shorts 5',
		factory: 'Apparels',
		price: 9.99,
		image: pdtShorts5,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Flexible shorts built for everyday movement.',
	},
	{
		id: 'P-8506',
		sku: 'SK-SH-8506',
		name: 'Shorts 6',
		factory: 'Apparels',
		price: 9.99,
		image: pdtShorts6,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Comfortable shorts for regular casual wear.',
	},
	{
		id: 'P-8507',
		sku: 'SK-SH-8507',
		name: 'Shorts 7',
		factory: 'Apparels',
		price: 9.99,
		image: pdtShorts7,
		tags: ['shorts', 'bottoms', 'casual'],
		description: 'Soft and durable shorts with an easy fit.',
	},
	{
		id: 'P-8508',
		sku: 'SK-SH-8508',
		name: 'Shorts Combo',
		factory: 'Apparels',
		price: 9.99,
		image: pdtShortsCombo,
		tags: ['shorts', 'combo', 'casual'],
		description: 'Multipack shorts combo for everyday rotation.',
	},
	{
		id: 'P-8601',
		sku: 'SK-PK-8601',
		name: 'Kids Pyjama',
		factory: 'Apparels',
		price: 9.99,
		image: pdtPyjamaKids,
		tags: ['pyjama', 'kids', 'nightwear'],
		description: 'Soft kids pyjama set for cozy bedtime comfort.',
	},
	{
		id: 'P-3003',
		sku: 'SK-JG-3003',
		name: 'Joggers 2',
		factory: 'Apparels',
		price: 9.99,
		image: pdtJogger2,
		tags: ['joggers', 'pants', 'casual'],
		description: 'Athleisure joggers designed for daily movement.',
	},
	{
		id: 'P-3004',
		sku: 'SK-JG-3004',
		name: 'Joggers 3',
		factory: 'Apparels',
		price: 9.99,
		image: pdtJogger3,
		tags: ['joggers', 'pants', 'casual'],
		description: 'Durable joggers offering comfort and flexibility.',
	},
	{
		id: 'P-9001',
		sku: 'SK-AS-9001',
		name: 'Arc Suit',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtArcSuit,
		tags: ['arc', 'suit', 'protective'],
		description: 'Protective arc suit for safety.',
	},
	{
		id: 'P-9002',
		sku: 'SK-FS-9002',
		name: 'FRC Suit',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtFrcSuit,
		tags: ['frc', 'suit', 'protective'],
		description: 'Flame-resistant suit for hazardous work.',
	},
	{
		id: 'P-9012',
		sku: 'SK-FR-9012',
		name: 'FRC Garment',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtFrc,
		tags: ['frc', 'protective', 'workwear'],
		description: 'Protective FRC garment built for industrial safety.',
	},
	{
		id: 'P-9003',
		sku: 'SK-FC-9003',
		name: 'FRC Coverall',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtFrcCoverall,
		tags: ['frc', 'coverall', 'protective'],
		description: 'Durable coverall for industrial use.',
	},
	{
		id: 'P-9004',
		sku: 'SK-MS-9004',
		name: 'Medical Scrubs',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtMedicalScrubs,
		tags: ['medical', 'scrubs', 'healthcare'],
		description: 'Comfortable medical scrubs for professionals.',
	},
	{
		id: 'P-9013',
		sku: 'SK-MS-9013',
		name: 'Medical Scrubs 2',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtMedicalScrubsAlt,
		tags: ['medical', 'scrubs', 'healthcare'],
		description: 'Alternate scrub style with soft all-day comfort.',
	},
	{
		id: 'P-9005',
		sku: 'SK-UP-9005',
		name: 'Uniform Polos',
		factory: 'Woven Garments',
		price: 9.99,
		image: pdtUnifromPolos,
		tags: ['uniform', 'polos', 'workwear'],
		description: 'Classic uniform polos for staff.',
	},
	{
		id: 'P-9006',
		sku: 'SK-WS-9006',
		name: 'Shirts & Trousers',
		factory: 'Woven Garments',
		price: 9.99,
		image: shirtImg,
		tags: ['shirt', 'woven', 'workwear'],
		description: 'Versatile woven shirt for daily work and wear.',
	},
	{
		id: 'P-9007',
		sku: 'SK-BX-9007',
		name: 'Boxer Shorts',
		factory: 'Woven Garments',
		price: 9.99,
		image: boxerImg,
		tags: ['boxer', 'shorts', 'innerwear'],
		description: 'Comfortable boxer shorts made for all-day wear.',
	},
	{
		id: 'P-9008',
		sku: 'SK-PJ-9008',
		name: 'Pyjama 1',
		factory: 'Woven Garments',
		price: 9.99,
		image: pyjamaImg,
		tags: ['pyjama', 'woven', 'nightwear'],
		description: 'Comfortable woven pyjama set for daily use.',
	},
	{
		id: 'P-9009',
		sku: 'SK-PJ-9009',
		name: 'Pyjama 2',
		factory: 'Woven Garments',
		price: 9.99,
		image: pyjamaImg2,
		tags: ['pyjama', 'woven', 'nightwear'],
		description: 'Soft woven pyjama set with breathable fabric.',
	},
	{
		id: 'P-9010',
		sku: 'SK-PS-9010',
		name: 'Printed Shirt 1',
		factory: 'Woven Garments',
		price: 9.99,
		image: printedShirt1,
		tags: ['shirt', 'printed', 'woven'],
		description: 'Printed woven shirt crafted for smart-casual wear.',
	},
	{
		id: 'P-1020',
		sku: 'SK-BT-1020',
		name: 'Bath Towels',
		factory: 'Home Textiles',
		price: 9.99,
		image: bathTowelsImg,
		tags: ['bath', 'towel', 'home'],
		description: 'Soft and absorbent bath towels for everyday use.',
	},
	{
		id: 'P-1021',
		sku: 'SK-BR-1021',
		name: 'Bath Robes',
		factory: 'Home Textiles',
		price: 9.99,
		image: bathRobesImg,
		tags: ['bath', 'robe', 'home'],
		description: 'Luxurious bath robes for a spa-like experience.',
	},
	{
		id: 'P-1011',
		sku: 'SK-BT-1011',
		name: 'Beach Towels',
		factory: 'Home Textiles',
		price: 9.99,
		image: beachtowelsImg,
		tags: ['beach', 'towel', 'outdoor'],
		description: 'Absorbent beach towels designed for comfort and travel.',
	},
	{
		id: 'P-1006',
		sku: 'SK-BC-1006',
		name: 'Bench Cover',
		factory: 'Home Textiles',
		price: 9.99,
		image: benchcoverImg,
		tags: ['bench', 'cover', 'decor'],
		description: 'Protective and stylish bench cover for indoor seating.',
	},
	{
		id: 'P-1018',
		sku: 'SK-CP-1018',
		name: 'Chair Pads',
		factory: 'Home Textiles',
		price: 9.99,
		image: chairPadsImg,
		tags: ['chair', 'pad', 'comfort'],
		description: 'Comfortable chair pads to enhance seating experience.',
	},
	{
		id: 'P-1007',
		sku: 'SK-CC-1007',
		name: 'Chair Cover',
		factory: 'Home Textiles',
		price: 9.99,
		image: chairCoverImg,
		tags: ['chair', 'cover', 'home'],
		description: 'Neat chair cover to refresh and protect furniture.',
	},
	{
		id: 'P-1012',
		sku: 'SK-CT-1012',
		name: 'Curtains',
		factory: 'Home Textiles',
		price: 9.99,
		image: curtainsImg,
		tags: ['curtain', 'window', 'decor'],
		description: 'Elegant curtains to enhance privacy and interior style.',
	},
	{
		id: 'P-1013',
		sku: 'SK-FB-1013',
		name: 'Fruit Bags',
		factory: 'Home Textiles',
		price: 9.99,
		image: fruitBagsImg,
		tags: ['fruit', 'bag', 'storage'],
		description: 'Reusable fruit bags for convenient produce storage.',
	},
	{
		id: 'P-1017',
		sku: 'SK-HT-1017',
		name: 'Hand Towels',
		factory: 'Home Textiles',
		price: 9.99,
		image: handTowelsImg,
		tags: ['hand', 'towel', 'bathroom'],
		description: 'Soft hand towels for bathroom and kitchen use.',
	},
	{
		id: 'P-1003',
		sku: 'SK-LB-1003',
		name: 'Laundry Bag',
		factory: 'Home Textiles',
		price: 9.99,
		image: laundryBagImg,
		tags: ['laundry', 'bag', 'storage'],
		description: 'Spacious laundry bag for organized clothing storage.',
	},
	{
		id: 'P-1010',
		sku: 'SK-NK-1010',
		name: 'Napkins',
		factory: 'Home Textiles',
		price: 9.99,
		image: napkinImg,
		tags: ['napkin', 'dining', 'linen'],
		description: 'Soft fabric napkins suitable for everyday dining.',
	},
	{
		id: 'P-1014',
		sku: 'SK-OP-1014',
		name: 'Oven Mitts & Pots',
		factory: 'Home Textiles',
		price: 9.99,
		image: oventMitsPotsImg,
		tags: ['oven', 'mitts', 'kitchen'],
		description: 'Heat-resistant oven mitt and pot set for safe cooking.',
	},
	{
		id: 'P-1008',
		sku: 'SK-PM-1008',
		name: 'Placemat',
		factory: 'Home Textiles',
		price: 9.99,
		image: placematImg,
		tags: ['placemat', 'table', 'dining'],
		description: 'Elegant placemat for daily and festive dining tables.',
	},
	{
		id: 'P-1009',
		sku: 'SK-RN-1009',
		name: 'Runners',
		factory: 'Home Textiles',
		price: 9.99,
		image: runnersImg,
		tags: ['runner', 'table', 'decor'],
		description: 'Classic table runner to elevate table presentation.',
	},
	{
		id: 'P-1015',
		sku: 'SK-SC-1015',
		name: 'Shower Curtains',
		factory: 'Home Textiles',
		price: 9.99,
		image: showerCurtainsImg,
		tags: ['shower', 'curtain', 'bathroom'],
		description: 'Durable shower curtains for a clean and stylish bathroom.',
	},
	{
		id: 'P-1016',
		sku: 'SK-ST-1016',
		name: 'Sofa Throw',
		factory: 'Home Textiles',
		price: 9.99,
		image: sofaThrowImg,
		tags: ['sofa', 'throw', 'decor'],
		description: 'Cozy sofa throw to add warmth and style to living spaces.',
	},
	{
		id: 'P-1001',
		sku: 'SK-AP-1001',
		name: 'Apron',
		factory: 'Home Textiles',
		price: 9.99,
		image: apronImg,
		tags: ['apron', 'kitchen', 'home'],
		description: 'Durable apron ideal for kitchen and utility use.',
	},
	{
		id: 'P-1002',
		sku: 'SK-TC-1002',
		name: 'Table Cloth',
		factory: 'Home Textiles',
		price: 9.99,
		image: tableCothImg,
		tags: ['table', 'cloth', 'dining'],
		description: 'Decorative table cloth for a refined dining setup.',
	},
	{
		id: 'P-1004',
		sku: 'SK-TB-1004',
		name: 'Tote Bag',
		factory: 'Home Textiles',
		price: 9.99,
		image: totebagImg,
		tags: ['tote', 'bag', 'carry'],
		description: 'Reusable tote bag for shopping and daily essentials.',
	},
	{
		id: 'P-1005',
		sku: 'SK-FC-1005',
		name: 'Floor Cushion',
		factory: 'Home Textiles',
		price: 9.99,
		image: fcushionImg,
		tags: ['cushion', 'floor', 'decor'],
		description: 'Soft floor cushion to add comfort and style at home.',
	},
];

const FACTORIES = ['All', 'Apparels', 'Woven Garments', 'Home Textiles'];

function Products() {
	const [query, setQuery] = useState('');
	const [factory, setFactory] = useState('All');

	const filtered = useMemo(() => {
		const q = query.trim().toLowerCase();
		return PRODUCTS.filter((p) => {
			const matchesFactory = factory === 'All' || p.factory === factory;
			const matchesQuery =
				!q ||
				p.name.toLowerCase().includes(q) ||
				p.sku.toLowerCase().includes(q) ||
				p.id.toLowerCase().includes(q) ||
				p.tags?.some((t) => t.toLowerCase().includes(q));
			return matchesFactory && matchesQuery;
		});
	}, [query, factory]);

	return (
		<section className="page products">
			<h2>Our Products</h2>
			<p>Explore our diverse product range from both factories.</p>

			<div className="products-controls">
				<input
					type="search"
					placeholder="Search by name, SKU, tag..."
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					className="products-search"
					aria-label="Search products"
				/>
				<div
					className="products-filters"
					role="tablist"
					aria-label="Factory filter"
				>
					{FACTORIES.map((f) => (
						<button
							key={f}
							role="tab"
							aria-selected={factory === f}
							className={`chip ${factory === f ? 'active' : ''}`}
							onClick={() => setFactory(f)}
						>
							{f}
						</button>
					))}
				</div>
			</div>

			<div className="products-grid">
				{filtered.map((p) => (
					<ProductCard
						key={p.id}
						product={p}
					/>
				))}
			</div>

			{filtered.length === 0 && (
				<div className="products-empty">
					<p>No products match your search.</p>
				</div>
			)}
		</section>
	);
}

export default Products;
